import type { ProductLightDto } from "../../../domain/types/shop";
import type { ProductEntity } from "../../../domain/types/product";
import type { ShopProductRepository } from "../../../domain/repositories/shop/shop-product-repository";
import { shopProductApiService } from "../../api/shop/shop-product-api-service";
import type {
  ShopProduct,
  ShopProductDetail,
  ProductOptionResponse,
  ProductOptionRequest,
  CalculatePriceResponse,
} from "../../../domain/types/shop-product";
import {
  ShopProductListResponseSchema,
  ShopProductDetailResponseSchema,
  ProductOptionApiResponseSchema,
  CalculatePriceApiResponseSchema,
} from "../../../domain/types/shop-product";

export class ShopProductRepositoryImpl implements ShopProductRepository {
    async getBestsellerList(shopId: number): Promise<ProductLightDto[]> {
    const response =
      await shopProductApiService.getBestsellerList(shopId);

    if (response.data) {
      return response.data;
    }

    throw new Error(response.errorMsg || "최근 둘러본 상품 가져오기 실패.");
  }

  async getRecentlyViewedProducts(shopId: number): Promise<ProductEntity[]> {
    const response =
      await shopProductApiService.getRecentlyViewedProducts(shopId);

    if (response.data) {
      return response.data;
    }

    throw new Error(response.errorMsg || "최근 둘러본 상품 가져오기 실패.");
  }

  async getProductList(shopId: number): Promise<ProductLightDto[]> {
    const response = await shopProductApiService.getProductList(shopId);

    if (response.data) {
      return response.data;
    }

    throw new Error(response.errorMsg || "최근 둘러본 상품 가져오기 실패.");
  }
  
  async getProducts(shopId: number): Promise<ShopProduct[]> {
    const response = await shopProductApiService.getProducts(shopId);

    const parsed = ShopProductListResponseSchema.safeParse(response);
    if (!parsed.success) {
      const issues = parsed.error.issues.map(i => `${i.path.join(".")}: ${i.message}`).join("; ");
      throw new Error(`ShopProductListResponse schema validation failed: ${issues}`);
    }

    return parsed.data.data;
  }

  async getProductDetail(shopId: number, productId: number): Promise<ShopProductDetail> {
    const response = await shopProductApiService.getProductDetail(shopId, productId);

    const parsed = ShopProductDetailResponseSchema.safeParse(response);
    if (!parsed.success) {
      const issues = parsed.error.issues.map(i => `${i.path.join(".")}: ${i.message}`).join("; ");
      throw new Error(`ShopProductDetailResponse schema validation failed: ${issues}`);
    }

    return parsed.data.data;
  }

  async getProductOptions(
    shopId: number,
    productId: number,
    request?: ProductOptionRequest
  ): Promise<ProductOptionResponse> {
    const response = await shopProductApiService.getProductOptions(shopId, productId, request);

    const parsed = ProductOptionApiResponseSchema.safeParse(response);
    if (!parsed.success) {
      const issues = parsed.error.issues.map(i => `${i.path.join(".")}: ${i.message}`).join("; ");
      throw new Error(`ProductOptionApiResponse schema validation failed: ${issues}`);
    }

    return parsed.data.data;
  }

  async calculatePrice(
    shopId: number,
    productId: number,
    request: ProductOptionRequest
  ): Promise<CalculatePriceResponse> {
    const response = await shopProductApiService.calculatePrice(shopId, productId, request);

    const parsed = CalculatePriceApiResponseSchema.safeParse(response);
    if (!parsed.success) {
      const issues = parsed.error.issues.map(i => `${i.path.join(".")}: ${i.message}`).join("; ");
      throw new Error(`CalculatePriceApiResponse schema validation failed: ${issues}`);
    }

    return parsed.data.data;
  }
}
